export default [
  { name: 'CUSTOMER', value: 1 },
  { name: 'HOUSE', value: 2 },
  { name: 'MARKET MAKER', value: 3 },
];

export const ORIGINS = {
  CUSTOMER: 1,
  HOUE: 2,
  MARKET_MAKER: 3,
};
